import "./App.css";
import "./style/style.css";

import { Routes, Route } from "react-router-dom";

import NavbarAtas from "./components/NavbarAtas";

import MenuPertama from "./components/MenuPertama";
import MenuKedua from "./components/MenuKedua";

function App() {
  return (
    <div className="MainContent">
      <div className="Navbar">
        <NavbarAtas />
      </div>
      <Routes>
        <Route path="/" element={<MenuPertama />} />
        <Route path="projects" element={<MenuKedua />} />
      </Routes>
    </div>
  );
}

export default App;
